import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Toaster } from 'sonner';
import { router } from './App';
import { ConfirmProvider } from './components/confirm';
import { reloadForUpdate } from './lib/app-update';
import { AuthProvider } from './lib/auth';
import { queryClient } from './lib/query';
import './styles.css';

// Production: keep the app shell available offline so the emergency list opens during an outage.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js').catch(() => undefined));
}

// A page's files could not be fetched ahead of it, usually because the system was updated while it was open.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadForUpdate()) event.preventDefault();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ConfirmProvider>
          <RouterProvider router={router} />
          <Toaster position="top-right" richColors closeButton toastOptions={{ className: 'text-[13px]' }} />
        </ConfirmProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
